"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PointerifyDynamicEvent_1 = require("./PointerifyDynamicEvent");
exports.DynamicEvent = PointerifyDynamicEvent_1.default;
var PointerifyStaticEvent_1 = require("./PointerifyStaticEvent");
exports.StaticEvent = PointerifyStaticEvent_1.default;
//# sourceMappingURL=index.js.map